import { ca } from '@cian/analytics';
//@ts-expect-error no types
import { ICommandEventSiteData } from '@cian/analytics/dist/command';

export function trackUpsaleCarouselEvent(eventData: ICommandEventSiteData) {
  ca('eventSite', eventData);
}
